import type { JSX } from 'react';
import buildings from '@/enterprise/assets/buildings.svg?url';
import priceTag from '@/enterprise/assets/pricetag.svg?url';
import smokestack from '@/enterprise/assets/smokestack.svg?url';
import { MANUAL_CUSTOMERS_CONTENT } from './content';

const ValuePropIllustration = ({ id }: { id: (typeof MANUAL_CUSTOMERS_CONTENT.valueProps)[number]['id'] }) => {
  if (id === 'search') {
    return <img alt="" src={buildings} width={103} height={102} />;
  }

  if (id === 'required') {
    return <img alt="" src={smokestack} width={96} height={96} />;
  }

  return <img alt="" src={priceTag} width={101} height={100} />;
};

export const NoCustomersAddedState = (): JSX.Element => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
    {MANUAL_CUSTOMERS_CONTENT.valueProps.map((prop) => (
      <div
        key={prop.id}
        className={`flex flex-col items-center justify-center gap-2 rounded-xl px-4 py-6 text-center ${prop.cardClassName}`}
      >
        <ValuePropIllustration id={prop.id} />
        <p className="m-0 p-0 text-base leading-normal text-text-primary">
          {prop.parts.map((part) =>
            'emphasis' in part && part.emphasis ? (
              <span key={part.text} className="font-bold">
                {part.text}
              </span>
            ) : (
              <span key={part.text}>{part.text}</span>
            )
          )}
        </p>
      </div>
    ))}
  </div>
);
